import * as dd from 'dingtalk-jsapi';
import {authenticate, sign} from "@/api/nb";

// 重新登录
export function resetLogin (datas) {
	return new Promise(function (resolve, reject) {
		let that = this
		dd.ready(function () {
			console.log('datas', datas)
			let site = datas ? datas : uni.getStorageSync('siteInfo')
			dd.runtime.permission.requestAuthCode({
				corpId: site.CorpId, // 企业id
				onSuccess: function (info) {
					console.log('info', info)
					authenticate({authCode: info.code}).then(res => {
						console.log('res', res)
						let data = JSON.stringify(res.data)
						console.log('data', data)
						localStorage.setItem('userInfo', data)
						resolve(res.data)
					})
				},
				onFail: function (err) {
					console.log(err)
					reject()
				}
			});
		})
		// dd.error(function (err) {
		// 	console.log('dd error: ' + JSON.stringify(err));
		// 	let bool = confirm('请在通好办APP内访问')
		// 	if (bool) {
		// 		window.close();
		// 	}
		// })
	})
}


// 重新登录
export function pageSign () {
	return new Promise(function (resolve, reject) {
		dd.ready(function () {
			let params = {
				url: location.href
			}
			sign(params).then(res => {
				let signData = res.data;
				dd.config({
					agentId: signData.agentId, // 必填，微应用ID
					corpId: signData.corpId,//必填，企业ID
					timeStamp: signData.timeStamp, // 必填，生成签名的时间戳
					nonceStr: signData.nonceStr, // 必填，自定义固定字符串。
					signature: signData.signature, // 必填，签名
					type: 0,   //选填。0表示微应用的jsapi,1表示服务窗的jsapi；不填默认为0。该参数从dingtalk.js的0.8.3版本开始支持
					jsApiList: [
						'device.notification.confirm',
						'device.notification.showPreloader',
						'device.notification.hidePreloader',
						'biz.util.saveImage',
						'biz.util.shareImage',
						'device.notification.alert',
						'device.notification.toast',
						'biz.util.share'
					] // 必填，需要使用的jsapi列表，注意：不要带dd。
				});
				resolve()

			})
		})
		//如果是PC端
		dd.error(function (err) {
			console.log('dd error: ' + JSON.stringify(err));
			let bool = confirm('请在通好办APP内访问')
			if (bool) {
				window.close();
			}
		})//该方法必须带上，用来捕获鉴权出现的异常信息，否则不方便排查出现的问题
	})
}

export function isMobile()	{
	const userAgent = navigator.userAgent || "";
	// 新增 HarmonyOS、HuaweiHarmony 等鸿蒙特征，保留原有移动设备标识
	const flag = userAgent.match(
		/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|HarmonyOS|HuaweiHarmony|HongMeng)/i
	);
	return flag; // 匹配到返回匹配结果数组，未匹配返回null
};
